import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { ChangeEvent, ReactElement } from "react";
import { useTranslation } from "react-i18next";

import ItemAndPrice from "../../../components/elements/General/ItemAndPrice";
import { useConfigContext } from "../../../contexts/ConfigContext/ConfigContext";
import { DINING_TYPE } from "../../constants";

interface IProps {
	value: DINING_TYPE;
	onChange: (evt: ChangeEvent<HTMLInputElement>, value: string) => void;
}

const ChangeDineInTakeaway = ({ onChange, value }: IProps): ReactElement => {
	const { t } = useTranslation();
	const { state: takeaway_fee } = useConfigContext((state) => state.config.takeaway_fee);
	const dineinclass = value === DINING_TYPE.DINEIN ? "Selected" : "";
	const takeawayclass = value === DINING_TYPE.TAKEAWAY ? "Selected" : "";

	return (
		<div className="PopupDialogContent">
			<div className="Title">{t("cartPage.changediningoption.title")}</div>
			<RadioGroup
				aria-label="DineIn Or Takeaway Selection"
				name="dinein-takeaway-selection"
				value={value}
				onChange={onChange}
				className="RadioSelection"
			>
				<FormControlLabel
					className={dineinclass}
					value={DINING_TYPE.DINEIN}
					control={<Radio />}
					label={t("DiningOptionsPage.dinein")}
				/>
				<FormControlLabel
					className={takeawayclass}
					value={DINING_TYPE.TAKEAWAY}
					control={<Radio />}
					label={<ItemAndPrice label="DiningOptionsPage.takeaway" price={takeaway_fee} />}
				/>
			</RadioGroup>
		</div>
	);
};

export default ChangeDineInTakeaway;
